var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8V6C17 4.11438 17 3.17157 16.4142 2.58579C15.8284 2 14.8856 2 13 2H11C9.11438 2 8.17157 2 7.58579 2.58579C7 3.17157 7 4.11438 7 6V8",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5641 5.78408C11.4593 5.29593 12.5412 5.29593 13.4365 5.78408L18.2307 8.39826C19.1947 8.92389 19.7945 9.93416 19.7945 11.0321V15.9698C19.7945 17.0678 19.1947 18.078 18.2307 18.6037L13.4365 21.2178C12.5412 21.706 11.4593 21.706 10.5641 21.2178L5.76986 18.6037C4.80588 18.078 4.20605 17.0678 4.20605 15.9698V11.0321C4.20605 9.93416 4.80588 8.9239 5.76986 8.39826L10.5641 5.78408Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1459 11.5225C11.5259 10.8408 11.7159 10.5 12 10.5C12.2841 10.5 12.4741 10.8408 12.8541 11.5225L12.9524 11.6989C13.0603 11.8926 13.1143 11.9894 13.1985 12.0533C13.2827 12.1172 13.3875 12.141 13.5972 12.1884L13.7881 12.2316C14.526 12.3986 14.895 12.482 14.9828 12.7643C15.0706 13.0466 14.819 13.3407 14.316 13.929L14.1858 14.0812C14.0429 14.2483 13.9714 14.3319 13.9392 14.4353C13.9071 14.5387 13.9179 14.6502 13.9395 14.8733L13.9592 15.0763C14.0352 15.8612 14.0733 16.2536 13.8435 16.4281C13.6136 16.6025 13.2682 16.4435 12.5773 16.1254L12.3986 16.0431C12.2022 15.9527 12.1041 15.9075 12 15.9075C11.8959 15.9075 11.7978 15.9527 11.6014 16.0431L11.4227 16.1254C10.7318 16.4435 10.3864 16.6025 10.1565 16.4281C9.92674 16.2536 9.96476 15.8612 10.0408 15.0763L10.0605 14.8733C10.0821 14.6502 10.0929 14.5387 10.0608 14.4353C10.0286 14.3319 9.95713 14.2483 9.81418 14.0812L9.68403 13.929C9.18097 13.3407 8.92945 13.0466 9.01723 12.7643C9.10501 12.482 9.47396 12.3986 10.2119 12.2316L10.4028 12.1884C10.6125 12.141 10.7173 12.1172 10.8015 12.0533C10.8857 11.9894 10.9397 11.8926 11.0476 11.6989L11.1459 11.5225Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalStar);
export default __webpack_public_path__ + "static/media/Medal Star.9e2e6227a50147acf16fb932c97d51cd.svg";
export { ForwardRef as ReactComponent };